import React from "react";
import { SectionContext } from "./../context";
import { pageDocPath } from "../../../../helpers";
import heroCards from "./quiz-hero-cards.json";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowCircleUp } from "@fortawesome/free-solid-svg-icons";
import { ArrowRight } from "../../icon/arrow-left";
import { QuizSectionHeader } from "./quiz-blocks";

const getHeroCardByCompany = (companyName) => {
  if (!companyName) return null;
  return heroCards.cards.find(card =>
    card.company.toLowerCase() === companyName.toLowerCase()
  );
};

export const QuizProof = ({ section }) => (
  <SectionContext.Provider value={{ isDarkBg: true }}>
    <QuizSectionHeader
      bgTitle="The Proof"
      title="Proven by battle-tested GTM heroes"
      summary="Across business models and motions, pipeline heroes like you use Common Room to wield the ultimate GTM superpower: relevance."
    />
    <div className="max-w-xs md:max-w-7xl mx-auto">
      {/* Customer Stories Grid */}
      {section.list && section.list.length > 0 && (
        <div className="grid md:grid-cols-3 gap-6 md:gap-3 lg:gap-6">
          {section.list.map((story) => {
            const heroCard = getHeroCardByCompany(story.company?.title);
            const backgroundImage = heroCard ? `/img/quiz/${heroCard.fileName}` : null;

            return (
              <a
                key={story.id}
                target="_blank"
                href={pageDocPath(story)}
                className="group block relative rounded-xl overflow-hidden border border-dark-60 hover:border-light-20 transition-all duration-300 transform scale-100 hover:scale-102 hover:shadow-lg"
                style={{
                  transition: 'box-shadow 0.3s ease-in-out, transform 0.3s ease-in-out, border-color 0.3s ease-in-out',
                }}
                onMouseEnter={(e) => {
                  const glowColor = heroCard?.color || '#1BC88C';
                  e.currentTarget.style.boxShadow = `0 0 40px ${glowColor}40, 0 0 80px ${glowColor}40`;
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.boxShadow = '';
                }}
              >
                {/* Background Image */}
                {backgroundImage && (
                  <img
                    src={backgroundImage}
                    alt=""
                    className="w-full h-auto object-cover"
                  />
                )}

                {/* Content */}
                <div className="absolute inset-0 z-10 px-2 py-6 lg:px-6 flex flex-col justify-end">
                  {story.statistics && (
                    <div className="group-hover:scale-105 transform scale-100 transition-size duration-300 flex gap-1.5 items-center rounded-full text-black lg:font-medium px-2 py-1.5 lg:py-3 lg:py-2 mb-3 lg:mb-6 bg-green-emerald text-sm w-max">
                      <FontAwesomeIcon icon={faArrowCircleUp} size="sm" className="max-h-4" />
                      <span>{story.statistics[0].number} {story.statistics[0].suffix}</span>
                    </div>
                  )}
                  <div className="text-white text-sm group-hover:text-link flex items-center">
                    Read case study <ArrowRight className="inline-block ml-2 mt-px" size={12} />
                  </div>
                </div>
              </a>
            );
          })}
        </div>
      )}
    </div>
  </SectionContext.Provider>
);